import { Alert, Box, CircularProgress, Grid, IconButton, Typography } from '@mui/material';
import React, { Component } from 'react';
import Dialog from '../../../common/Dialog';
import InputText, { InputSelectNative } from '../../../common/Form';
import DatePickerCmp from '../../../common/DatePicker';
import { GroupRadio, SingleRadio } from '../../../common/RadioAndCheckbox';
import PhotoUpload from '../../../common/PhotoUpload';
import Creatable from '../../../common/Creatable';
import _, { isEmpty } from 'lodash';
import { Fragment } from 'react';
import { QrCodeScannerRounded, ScannerRounded } from '@mui/icons-material';
import ScanQrCodeReturn from './ScanQrCodeReturn';
import { extension } from 'mime-types';

const HEADER = {
    "immo" : "Immobilisation",
    "materiel" : "Matériel",
    "car" : "Véhicule",
}

class Restitution extends Component {
    state = { 
        loan_end_date: new Date(),
        loan_estimated_return: new Date(),
        loan_km_end: "",
        loan_fuel_end: "",
        loan_photo_back_end: null,
        loan_photo_front_end: null,
        loan_photo_top_end: null,
        loan_photo_bottom_end: null,
        loan_photo_left_end: null,
        loan_photo_right_end: null,
        loan_user: this.props.loan ? this.props.loan.loan_user : "",
        loan_userDisplay: this.props.loan && this.props.loan.loan_user ? {
            value: this.props.loan.loan_user, 
            label: this.props.USERS[this.props.loan.loan_user].user_name
        } : {value:"", label:""},

        loan_equipement: this.props.loan ? this.props.loan.loan_equipement : "",
        loan_equipementDisplay: this.props.loan && this.props.loan.loan_equipement ? {
            value: this.props.loan.loan_equipement, 
            label: this.props.EQUIPEMENTS[this.props.loan.loan_equipement].loan_name
        } : {value:"", label:""},

        loan_vehicule: this.props.loan ? this.props.loan.loan_vehicule : "",
        loan_vehiculeDisplay: this.props.loan && this.props.loan.loan_vehicule ? {
            value: this.props.loan.loan_vehicule, 
            label: this.props.EQUIPEMENTS[this.props.loan.loan_vehicule].loan_name
        } : {value:"", label:""},

        loan_equipement_type: "",
        errors: {},
        is_permanent: "",
        openScan: false,
        loan: {},
        equipement: {},
    }
    componentDidMount = () => {
        const { defaultItem } = this.props;
        if (!isEmpty(defaultItem)) {
            let option = {
                label: `${defaultItem.equipement_ref.toUpperCase()} | ${defaultItem.equipement_name}`,
                value: defaultItem.equipement_id,
                permanent: defaultItem.permanent_loan,
                // short: item.short_loan
            }
            console.log('=================RESTITUTION===================');
            console.log({option});
            console.log('====================================');
            this.setState({
                loan_equipement_type : defaultItem.equipement_type === "vehicule" ? "vehicule" : "equipement"
            })
            this.handleChangeSelect1("loan_equipement", option)
        }

    }
    handleChange = (e) => {
        const { name, value} = e.target;
        // TO DO add regex float
        this.setState({
            [name]: value
        })
    }
    handleChangeCheck = (e) => {
        const { name, value} = e.target;
        
        this.setState({
            [name]: value,

            loan_equipement: "",
            loan_equipementDisplay: {value:"", label:""},
            loan_vehicule: "",
            loan_vehiculeDisplay: {value:"", label:""},
            loan_user: "",
            loan_userDisplay: {value:"", label:""},
            loan: {}
        })
    }

    handleChangeDate = (name, date) => {
        let newDate = date.setHours(0,0, 0, 0)
        this.setState({
            [name]: new Date(newDate)
        })
    }

    fetchLoanList = async (equipID) => {
        const { LOANS_BY_EQUIP } = this.props;
        if (isEmpty(LOANS_BY_EQUIP[equipID])){
            await this.props.fetchEquipementLoans(equipID)
        }
    }
    handleChangeSelect1 = async (name, option) => {
       	const { LOANS, USERS } = this.props;
        if(option){
            await this.fetchLoanList(option.value)
            let result = _.find(Object.values(LOANS), obj => (obj[name] === option.value && !obj.is_over) )
        
            console.log('====================================');
            console.log({result});
            console.log('====================================');

            if (result){
                this.handleChangeSelect(name, option)
                let uInfo = USERS[result.loan_user]
                let user = {
                    label: `${uInfo.lastname.toUpperCase()} ${uInfo.username}`,
                    value: uInfo.user_id
                }
                this.handleChangeSelect(`loan_user`, user)
                this.setState({
                    loan: result,
                    equipement: option.equipement
                })
            }
        } else {
            this.handleChangeSelect(name, option)
            this.handleChangeSelect(`loan_user`, null)

        }
    }
    handleChangeSelect = (name, option) => {
        let is_permanent = this.state.is_permanent
        if(option){
            if (name !== "loan_user"){
                is_permanent = option.permanent
            }
            this.setState({
                [name]: option.value || "",
                [`${name}Display`]: option,
                is_permanent,
            })
        } else {
            this.setState({
                [name]: "",
                [`${name}Display`]: {},
                is_permanent,
            })
        }
    }

    openScanner = () => {
        this.setState({
            openScan : true
        })
    }

    setPhotos = (name, list) => {
        console.log("[INFO] SETPHOTOS", name, list);
        
        this.setState({
            [name]:list
        })
    }

    validate = () => {
        let noError = true
        let errors = {} 
        let required = [
            "loan_end_date",    
            "loan_photo_back_end",
            "loan_photo_front_end",
            "loan_photo_top_end",
            "loan_photo_bottom_end",
            "loan_photo_left_end",
            "loan_photo_right_end",
            "equipement_state_end",
            "equipement_state_end",
            "equipement_remarks_end",
        ]
            
        if( this.state.loan_equipement_type === "vehicule" ){
            required = required.concat([
                "loan_km_end",
                "loan_fuel_end",
            ])
        } 

        console.log('====================================');
        console.log({required});
        console.log('====================================');
        required.map(field => {
            if( !this.state[field] && isEmpty(this.state[field]) ) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce champ" 
            } else {
                errors[field] = "" 
            }
        })

        this.setState({
            errors
        })
        return noError
    }
    handleSubmit = async () => {

        if( !isEmpty(this.state.loan) && this.validate() ){
            let data = Object.assign({}, this.state.loan)
            // data.loan_id = this.state.loan.loan_id
            data.loan_end_date = this.state.loan_end_date
            data.equipement_remarks_end = this.state.equipement_remarks_end
            data.equipement_state_end = this.state.equipement_state_end
            
            data.loan_photo_back_end = this.state.loan_photo_back_end
            data.loan_photo_front_end = this.state.loan_photo_front_end
            data.loan_photo_top_end = this.state.loan_photo_top_end
            data.loan_photo_bottom_end = this.state.loan_photo_bottom_end
            data.loan_photo_left_end = this.state.loan_photo_left_end
            data.loan_photo_right_end = this.state.loan_photo_right_end
            data.is_over = true
            
            if (this.state.loan_equipement_type === "vehicule") {
                data.loan_km_end = parseFloat(this.state.loan_km_end)
                data.loan_fuel_end = parseFloat(this.state.loan_fuel_end)
            } 
           
            console.log('====================================');
            console.log("submit loan", {data});
            console.log('====================================');
            
            await this.props.endLoan(data)

            // // if NoErrors ...
            if(this.props.STATE.loans.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.loans.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }

    render() {
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        const { USERS, EQUIPEMENTS, VEHICULES } = this.props;
        const { openScan, loan } = this.state;

        return (
            <Dialog
                title={`Restituer un Équipement`}
                close={this.props.handleClose}
                appBar
                submitAction={this.handleSubmit}
                maxWidth="md"
            >
                {openScan &&
                    <ScanQrCodeReturn
                        handleClose={()=> this.setState({ openScan: false })}
                        title="Scanner un équipement"
                        VEHICULES={this.props.VEHICULES}
                        EQUIPEMENTS={this.props.EQUIPEMENTS}
                        LOANS={this.props.LOANS}
                        USERS={this.props.USERS}
                        equipement_type={this.state.loan_equipement_type}
                        setEquipement={(option) => this.handleChangeSelect1(`loan_${this.state.loan_equipement_type}`, option)}
                        // setUser={(option) => this.handleChangeSelect(`loan_user`, option)}
                        // setLoan={(loan) => this.setState({loan})}
                    />
                }
                <Grid container >
                    <Grid item xs={12}>
                        <Box p={1}>
                            <GroupRadio groupName="loan_equipement_type" value={this.state.loan_equipement_type}  onChange={this.handleChangeCheck} >
                                <SingleRadio 
                                    value="equipement" 
                                    checked={this.state.loan_equipement_type === "equipement" } 
                                    disabled={!isEmpty(this.props.defaultItem) && this.state.loan_equipement_type !== "equipement" } 
                                    label="Immo / Matériel" 
                                    />
                                <SingleRadio 
                                    value="vehicule" 
                                    checked={this.state.loan_equipement_type === "vehicule"} 
                                    disabled={!isEmpty(this.props.defaultItem) && this.state.loan_equipement_type !== "vehicule" } 
                                    label="Véhicule" 
                                />
                            </GroupRadio>
                        </Box>
                    </Grid>
                    
                    {this.state.loan_equipement_type === "equipement" && 
                        <Grid item xs={12}>
                            {!isEmpty(EQUIPEMENTS) && !isEmpty(Object.values(EQUIPEMENTS).filter(e => e.equipement_status === "loan")) ? 
                                <Box style={{display:"flex"}}>
                                    <Creatable
                                        label="Équipement"
                                        required
                                        error={this.state.errors.loan_equipement}
                                        id="loan_equipement"
                                        labelWidth={100} 
                                        options={Object.values(EQUIPEMENTS).filter(e => e.equipement_status === "loan").map( item => ({
                                            label: `${item.equipement_ref.toUpperCase()} | ${item.equipement_name}`,
                                            value: item.equipement_id,
                                            equipement: item,
                                            permanent: item.permanent_loan,
                                            // short: item.short_loan
                                        }))}
                                        value={this.state.loan_equipementDisplay}
                                        onChange={(option) => this.handleChangeSelect1("loan_equipement", option)}
                                        disabled={!isEmpty(this.props.defaultItem)}
                                    />
                                    {isEmpty(this.props.defaultItem) &&
                                        <IconButton onClick={this.openScanner} color="primary">
                                            <QrCodeScannerRounded />
                                        </IconButton>
                                    }

                                </Box>
                                :
                                <Alert severity="warning">Aucun équipement disponible</Alert>
                            }
                        </Grid>
                    }
                    {this.state.loan_equipement_type === "vehicule" && 
                        <Grid item xs={12}>
                            {!isEmpty(VEHICULES) && !isEmpty(Object.values(VEHICULES).filter(e => e.equipement_status === "loan"))? 
                            <Box style={{display:"flex"}}>
                                <Creatable
                                    label="Véhicule"
                                    required
                                    error={this.state.errors.loan_vehicule}
                                    id="loan_vehicule"
                                    labelWidth={100} 
                                    options={Object.values(VEHICULES).filter(e => e.equipement_status === "loan").map( item => ({
                                        label: `${item.equipement_ref.toUpperCase()} | ${item.equipement_name}`,
                                        value: item.equipement_id,
                                        equipement: item,
                                        permanent: item.permanent_loan,
                                            // short: item.short_loan
                                    }))}
                                    value={this.state.loan_vehiculeDisplay}
                                    onChange={(option) => this.handleChangeSelect1("loan_vehicule", option)}
                                    disabled={!isEmpty(this.props.defaultItem)}
                                />
                                {isEmpty(this.props.defaultItem) &&
                                    <IconButton onClick={this.openScanner} color="primary">
                                        <QrCodeScannerRounded />
                                    </IconButton>
                                }

                            </Box>
                            :
                            <Alert severity="warning">Aucun véhicule disponible</Alert>
                            }
                        </Grid>
                    }
                    {this.props.STATE.loans.fetching ?
                        <Box p={1} style={{margin: "auto"}}>
                            <CircularProgress color="secondary" size={80}/>
                        </Box>
                        :
                        <>
                            {(!isEmpty(this.state.loan_equipement) || !isEmpty(this.state.loan_vehicule)) &&
                                <Fragment>
                                    <Grid item xs={12}>
                                        <hr />
                                        <Box p={1}>
                                            <Typography color="primary" variant="button" style={{fontWeight: "bold"}}>{this.state.is_permanent ? "Affectation Permanente" : "Emprunt"}</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        {!isEmpty(USERS) && 
                                            <Creatable
                                                label="Utilisateur"
                                                required
                                                error={this.state.errors.loan_user}
                                                id="loan_user"
                                                labelWidth={100} 
                                                options={Object.values(USERS).map( item => ({
                                                    label: `${item.lastname.toUpperCase()} ${item.username}`,
                                                    value: item.user_id
                                                }))}
                                                value={this.state.loan_userDisplay}
                                                disabled
                                                // onChange={(option) => this.handleChangeSelect("loan_user", option)}
                                            />
                                        }
                                    </Grid>
                                    <Grid item xs={12} sm={5}>
                                        <DatePickerCmp  
                                            id="loan_start_date" 
                                            label="Date d'attribution" 
                                            name="loan_start_date" 
                                            value={this.state.loan && this.state.loan.loan_start_date} 
                                            // handleChange={(option) => this.handleChangeDate("loan_start_date", option)} 
                                            // error={this.state.errors.loan_start_date}
                                            disabled
                                        />      
                                    </Grid>   
                                    <Grid item xs={12} sm={7}>
                                        <DatePickerCmp  
                                            id="loan_end_date" 
                                            label="Date de retour" 
                                            name="loan_end_date" 
                                            value={this.state.loan_end_date} 
                                            handleChange={(option) => this.handleChangeDate("loan_end_date", option)} 
                                            error={this.state.errors.loan_end_date}
                                            required
                                        />      
                                    </Grid>   
                                    {/* { !isEmpty(this.state.loan_equipement) && 
                                        <Fragment>
                                        </Fragment>
                                    } */}

                                    <Grid item xs={12}>
                                        <hr />
                                    </Grid>
                                    <Grid container item xs={12}>
                                        <Grid container item xs={12} sm={5}>
                                            <Grid item xs={12}>
                                                {/* <hr /> */}
                                                <Box p={1}>
                                                    <Typography variant="button" style={{fontWeight: "bold", color: "gray"}}>Départ</Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} >
                                                <InputSelectNative
                                                    labelWidth={60}
                                                    // onChange={ (e) => this.setState({ equipement_state_start: e.target.value })}
                                                    error={this.state.errors.equipement_state_start}
                                                    value={this.state.loan && this.state.loan.equipement_state_start}
                                                    label="Etat Général"
                                                    options={[
                                                        <option>Neuf</option>,
                                                        <option>Bon</option>,
                                                        <option>Moyen</option>,
                                                        <option>Mauvais</option>,
                                                    ]}
                                                    disabled
                                                />
                                            </Grid>
                                            <Grid item xs={12} >
                                                <InputText
                                                    // onChange={this.handleChange}
                                                    multiline
                                                    rows={2}
                                                    id="equipement_remarks_start"
                                                    // error={this.state.errors.equipement_remarks_start}
                                                    value={this.state.loan && this.state.loan.equipement_remarks_start}
                                                    name="equipement_remarks_start"
                                                    label="Remarques"
                                                    disabled
                                                />
                                            </Grid>
                                            { !isEmpty(this.state.loan_vehicule) &&                             
                                                <Fragment>  
                                                    <Grid item xs={12}>
                                                        <InputText
                                                            onChange={this.handleChange}
                                                            required
                                                            id="loan_km_start"
                                                            error={this.state.errors.loan_km_start}
                                                            value={this.state.loan && this.state.loan.loan_km_start}
                                                            name="loan_km_start"
                                                            label="Kilométrage Départ (Km)"
                                                            type="number"
                                                            disabled
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <InputText
                                                            onChange={this.handleChange}
                                                            required
                                                            id="loan_fuel_start"
                                                            error={this.state.errors.loan_fuel_start}
                                                            value={this.state.loan && this.state.loan.loan_fuel_start}
                                                            name="loan_fuel_start"
                                                            label="Niveau Carburant"
                                                            type="number"
                                                            disabled
                                                        />
                                                    </Grid>
                                                </Fragment>
                                            }
                                        </Grid>
                                        <Grid container item xs={12} sm={7} style={{ borderLeft: "1px dashed lightgray"}}>
                                            <Grid item xs={12}>
                                                {/* <hr /> */}
                                                <Box p={1}>
                                                    <Typography color="primary" variant="button" style={{fontWeight: "bold"}}>Retour</Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} >
                                                <InputSelectNative
                                                    labelWidth={60}
                                                    onChange={ (e) => this.setState({ equipement_state_end: e.target.value })}
                                                    error={this.state.errors.equipement_state_end}
                                                    value={this.state.equipement_state_end}
                                                    label="Etat Général"
                                                    options={[
                                                        <option>Neuf</option>,
                                                        <option>Bon</option>,
                                                        <option>Moyen</option>,
                                                        <option>Mauvais</option>,
                                                    ]}
                                                />
                                            </Grid>
                                            <Grid item xs={12} >
                                                <InputText
                                                    onChange={this.handleChange}
                                                    multiline
                                                    rows={2}
                                                    id="equipement_remarks_end"
                                                    error={this.state.errors.equipement_remarks_end}
                                                    value={this.state.equipement_remarks_end}
                                                    name="equipement_remarks_end"
                                                    label="Remarques"
                                                />
                                            </Grid>
                                            { !isEmpty(this.state.loan_vehicule) &&                             
                                                <Fragment>  
                                                    <Grid item xs={12}>
                                                        <InputText
                                                            onChange={this.handleChange}
                                                            required
                                                            id="loan_km_end"
                                                            error={this.state.errors.loan_km_end}
                                                            value={this.state.loan_km_end}
                                                            name="loan_km_end"
                                                            label="Kilométrage Retour (Km)"
                                                            type="number"
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <InputText
                                                            onChange={this.handleChange}
                                                            required
                                                            id="loan_fuel_end"
                                                            error={this.state.errors.loan_fuel_end}
                                                            value={this.state.loan_fuel_end}
                                                            name="loan_fuel_end"
                                                            label="Niveau Carburant Retour (%)"
                                                            type="number"
                                                        />
                                                    </Grid>
                                                </Fragment>
                                            }
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <hr />
                                        <Box p={1}>
                                            <Typography color="primary" variant="button" style={{fontWeight: "bold"}}>Photos</Typography>
                                        </Box>
                                    </Grid>
                                    {[
                                        {title:"Face Avant", name:"front"}, 
                                        {title:"Face Arrière", name:"back"}, 
                                        {title:"Haut",name:"top"}, 
                                        {title:"Bas",name:"bottom"}, 
                                        {title:"Gauche",name:"left"}, 
                                        {title:"Droite",name:"right"}
                                    ].map( side => 
                                        <Grid container item xs={12}>
                                            {!isEmpty(this.state.loan) &&
                                            <>
                                                <Grid item xs={12}>
                                                    <Box p={1}>
                                                        <Typography color="primary" variant="button" >{side.title}</Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid key={loan[`loan_photo_${side.name}_start`].filename} item xs={12} sm={5} >
                                                    {loan[`loan_photo_${side.name}_start`].filetype === "application/pdf" ?
                                                        <a href={`/photos/single/${loan[`loan_photo_${side.name}_start`].filename}`} 
                                                            download={`${side.name}.${ extension(loan[`loan_photo_${side.name}_start`].filetype) || "pdf"}`}
                                                        >
                                                            <embed 
                                                                src={`/photos/single/${loan[`loan_photo_${side.name}_start`].filename}`} 
                                                                width="100%" 
                                                                height="400px" 
                                                                title={side.name} 
                                                                type="application/pdf"
                                                            />
                                                        </a>
                                                        :
                                                        <a href={`/photos/single/${loan[`loan_photo_${side.name}_start`].filename}`} 
                                                            download={`${side.name}.${ extension(loan[`loan_photo_${side.name}_start`].filetype) || "jpeg"}`}
                                                        >
                                                            <img 
                                                                style={{opacity: ".7"}}
                                                                src={`/photos/single/${loan[`loan_photo_${side.name}_start`].filename}`} 
                                                                title={side.name} 
                                                                alt={side.name} 
                                                            />
                                                        </a>
                                                    }
                                                </Grid>

                                                <Grid item xs={12} sm={7}  style={{ borderLeft: "1px dashed lightgray"}}>
                                                    <Box p={1}>
                                                        <PhotoUpload 
                                                            id={side.name} 
                                                            label={`Photo ${side.title}`} 
                                                            setPhoto={(pic) => this.setPhotos(`loan_photo_${side.name}_end`, pic)} 
                                                            photos={this.state[`loan_photo_${side.name}_end`] === null ? [] : this.state[`loan_photo_${side.name}_end`] }
                                                            error={this.state.errors[`loan_photo_${side.name}_end`]}
                                                        />
                                                    </Box>
                                                </Grid>
                                            </>
                                            }
                                        </Grid>

                                    )}
                                    {/* <Grid container item xs={12} sm={7}>
                                        <Grid item xs={12}>
                                            <Box p={1}>
                                                <PhotoUpload id="ar" label="Photo Arrière" setPhoto={(pic) => this.setPhotos("loan_photo_back_end", pic)} photos={this.state.loan_photo_back_end === null ? [] : this.state.loan_photo_back_end }/>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Box p={1}>
                                                <PhotoUpload id="left" label="Photo Gauche" setPhoto={(pic) => this.setPhotos("loan_photo_left_end", pic)} photos={this.state.loan_photo_left_end === null ? [] : this.state.loan_photo_left_end }/>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Box p={1}>
                                                <PhotoUpload id="right" label="Photo Droite" setPhoto={(pic) => this.setPhotos("loan_photo_right_end", pic)} photos={this.state.loan_photo_right_end === null ? [] : this.state.loan_photo_right_end }/>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Box p={1}>
                                                <PhotoUpload id="top" label="Photo Haut" setPhoto={(pic) => this.setPhotos("loan_photo_top_end", pic)} photos={this.state.loan_photo_top_end === null ? [] : this.state.loan_photo_top_end }/>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Box p={1}>
                                                <PhotoUpload id="bottom" label="Photo Bas" setPhoto={(pic) => this.setPhotos("loan_photo_bottom_end", pic)} photos={this.state.loan_photo_bottom_end === null ? [] : this.state.loan_photo_bottom_end }/>
                                            </Box>
                                        </Grid>
                                    </Grid> */}
                                </Fragment>
                            }
                        </>
                    }
                </Grid>      
                
            </Dialog>
        );
    }
}

export default Restitution;


